<script setup lang="ts">
import {NuxtLink} from '#components';
defineOptions({inheritAttrs:false});
const props=defineProps<{variant?:'primary'|'secondary'|'danger'}>();
const attrs=useAttrs();
const kind=()=>props.variant || (/bg-(red|rose)/.test(String(attrs.class || ''))?'danger':/bg-(green|emerald|yellow)/.test(String(attrs.class || ''))?'primary':'secondary');
</script>
<template><component v-bind="$attrs" class="button uo-control-button" :class="'uo-control-'+kind()" :is="$attrs.to?NuxtLink:'button'"><slot /></component></template>
